// YNX — MASTER ADMIN API (Carl TACITA only)
// Sent X-YNX-Owner-Secret header on every call.
const API = process.env.REACT_APP_BACKEND_URL;

const headers = (secret) => ({
  'Content-Type': 'application/json',
  'X-YNX-Owner-Secret': secret,
});

const json = async (res) => {
  if (!res.ok) {
    let err = `HTTP ${res.status}`;
    // Intentional best-effort: keep HTTP status if body isn't JSON.
    try { const j = await res.json(); err = j.detail || err; }
    catch (parseErr) { console.debug('YNX admin: error body not JSON', parseErr); }
    throw new Error(err);
  }
  return res.json();
};

export const adminWhoami = (secret) =>
  fetch(`${API}/api/biz/admin/whoami`, { headers: headers(secret) }).then(json);

export const adminListWorkspaces = (secret, statusFilter = '') => {
  const q = statusFilter ? `?status=${statusFilter}` : '';
  return fetch(`${API}/api/biz/admin/workspaces${q}`, { headers: headers(secret) }).then(json);
};

export const adminBlockWorkspace = (secret, wsId) =>
  fetch(`${API}/api/biz/admin/workspaces/${wsId}/block`, { method: 'POST', headers: headers(secret) }).then(json);

export const adminUnblockWorkspace = (secret, wsId) =>
  fetch(`${API}/api/biz/admin/workspaces/${wsId}/unblock`, { method: 'POST', headers: headers(secret) }).then(json);

export const adminDeleteWorkspace = (secret, wsId) =>
  fetch(`${API}/api/biz/admin/workspaces/${wsId}`, { method: 'DELETE', headers: headers(secret) }).then(json);

export const adminListNotifications = (secret, unreadOnly = false) => {
  const q = unreadOnly ? '?unread_only=true' : '';
  return fetch(`${API}/api/biz/admin/notifications${q}`, { headers: headers(secret) }).then(json);
};

export const adminUnreadCount = (secret) =>
  fetch(`${API}/api/biz/admin/notifications/count`, { headers: headers(secret) }).then(json);

export const adminMarkRead = (secret, ntfId) =>
  fetch(`${API}/api/biz/admin/notifications/${ntfId}/read`, { method: 'POST', headers: headers(secret) }).then(json);

export const adminMarkAllRead = (secret) =>
  fetch(`${API}/api/biz/admin/notifications/mark-all-read`, { method: 'POST', headers: headers(secret) }).then(json);
